<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              modalWidth="80%"
              ref="master"
              :parentData="parentData"
              @action="masterActions"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :params="tipo_capacitador"
                        :label="$t('Tipo capacitador') "
                        :formItemConfig="fiOptions"
                        :selectedObj.sync="capacitorType"
                        ref="tipo_capacitador"
                        :decorator="['id_h_trainer_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
            >
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Tema')">
              <a-input
                v-decorator="['theme', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Año')" v-bind="fiOptions">
              <a-select v-decorator="['year', { rules: [
                            { required: false, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                <a-select-option v-for="year_ in years" :key="year_">
                  {{ year_ }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Mes')" v-bind="fiOptions">
              <a-select v-decorator="['month', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                <a-select-option v-for="month_ in months_name" :key="month_.value">
                  {{ month_.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Fecha Incio')" v-bind="fiOptions">
              <a-date-picker style="width: 100%"
                             valueFormat="Y-MM-DD HH:mm:ss"
                             v-decorator="['init_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Hora inicio')" v-bind="fiOptions">
              <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                             v-decorator="['start_time', {type:'object', rules: [{ required: false, message: 'Valor requerido' }] }]"
                             placeholder="H. Inicio"
                             style="width: 100%"
              ></a-time-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Hora fin')" v-bind="fiOptions">
              <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                             v-decorator="['end_time', {type:'object', rules: [{ required: false, message: 'Valor requerido' }] }]"
                             placeholder="H. Inicio"
                             style="width: 100%"
              ></a-time-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Observación')" v-bind="fiOptions">
              <a-textarea autoSize
                          v-decorator="['observation', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Fecha Fin')" v-bind="fiOptions">
              <a-date-picker style="width: 100%"
                             valueFormat="Y-MM-DD 00:00:00"
                             v-decorator="['end_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Hora Inicio')" v-bind="fiOptions">
              <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                             v-decorator="['start_time_of_end_date', {type:'object', rules: [{ required: false, message: 'Valor requerido' }] }]"
                             placeholder="H. Inicio"
                             style="width: 100%"
              ></a-time-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Hora Fin')" v-bind="fiOptions">
              <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                             v-decorator="['end_time_of_end_date', {type:'object', rules: [{ required: false, message: 'Valor requerido' }] }]"
                             placeholder="H. Inicio"
                             style="width: 100%"
              ></a-time-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions" v-show="isInternal">
            <g-lookup :label="$t('Capacitador')"
                      :formItemConfig="fiOptions"
                      endpoint="empleados"
                      :decorator="['trainer', { rules: [{ required: isInternal, message: 'Valor requerido' }] }]"
                      ref="capacitador"
            >
            </g-lookup>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Departamento capacitador')">
              <a-input
                v-decorator="['trainer_department', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <div v-show="!isInternal">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Documento de identificación')">
                <a-input v-decorator="['externa_trainer_id_person', { rules: [{ required: !isInternal }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Nombre completo')">
                <a-input v-decorator="['external_trainer_name', { rules: [{ required: !isInternal }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Email')">
                <a-input v-decorator="['external_trainer_email', {
                      rules: [{ required: !isInternal, message: 'Valor requerido' },
                      { pattern: modalPattern, message: 'Debe ser un correo válido.' }]}]"/>
              </a-form-item>
            </a-col>
          </div>
        </a-row>
      </template>
    </g-master>
    <a-modal title="Asistencia"
             :visible="modalVisible"
             width="70%"
             height="70%"
             @cancel="handleCancel"
             :footer="null"
    >
      <g-master :name="modal.endpoint"
                :endpoint="modal.endpoint"
                :tableSetup="modal.tableSetup"
                ref="masterAsistencia"
                :parentData="modalParenData"
      >
        <template slot="qualificationRenderer" slot-scope="{text, record, index}">
          {{loadingBtn[record.id]}}
          <a-spin :spinning="!$isEmpty(loadingBtn[record.id]) && loadingBtn[record.id]">
            <div class="spin-content">
              <input
                v-model="record.qualification"
                @blur="columnaCambiada (record)"
                style="width: 100%"
                type="text"
                class="ant-input ant-input-sm ctinput"
              />
            </div>
          </a-spin>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptionsModal">
              <g-dropdown endpoint="competitor"
                          :label="$t('Participante')"
                          :decorator="['id_competitor', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :selectConfig="{mode:'multiple'}"
                          :formItemConfig="fiOptions"
                          :params="parentData"
              >
              </g-dropdown>
            </a-col>
          </a-row>
        </template>

      </g-master>
    </a-modal>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="Evaluación y asistencia" key="1">
        <competitor v-if="rowSelected && rowSelected.id" :id_calendar="rowSelected && rowSelected.id"/>
        <span v-else>Seleccione una capacitación para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['id_training'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.yearsSelect()
    },
    data () {
      return {
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        master: {
          endpoint: 'calendar',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            actions: {
              width: 120,
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'asistencia',
                  text: 'Asistencia',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'carry-out', style: 'color: red'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'Tema', dataIndex: 'theme', sorter: true},
              {title: 'Tipo capacitador', dataIndex: 'h_trainer_type', sorter: true},
              {title: 'Capacitador', dataIndex: 'full_name_trainer', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'fecha_inicio', sorter: true},
              {title: 'Hora inicio', dataIndex: 'hora_inicio', sorter: true},
              {title: 'Hora fin', dataIndex: 'hora_fin', sorter: true},
              {title: 'Fecha fin', dataIndex: 'fecha_fin', sorter: true},
              {title: 'Hora inicio', dataIndex: 'hora_inicio_fecha_fin', sorter: true},
              {title: 'Hora fin', dataIndex: 'hora_fin_fecha_fin', sorter: true},
              {title: 'Observación', dataIndex: 'observation', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true}
            ]
          }
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        visibleModal: false,
        colOptionsModal: {xs: 24, sm: 24},
        modalVisible: false,
        modal: {
          endpoint: 'trn_assistance',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            columns: [
              {title: 'Asistencia', dataIndex: 'competitor_name', sorter: true},
              {
                title: 'Calificación',
                dataIndex: 'qualification',
                sorter: true,
                scopedSlots: {customRender: 'qualificationRenderer'}
              }
            ],
            tableConfig: {
              scroll: {x: 950, y: 250},
              rowKey: 'id'
            },
            customSlots: ['qualificationRenderer']
          }
        },
        id_calendar: null,
        tipo_capacitador: {h_lookup_type: 'TRN_TIPO_CAPACITADOR'},
        capacitorType: {},
        loadingBtn: {},
        loading: false,
        modalPattern: '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])'
      }
    },
    methods: {
      modeloRecibido (value) {
        this.$refs.master.modal.form.setFieldsValue({
          id_cc: value
        })
      },
      masterActions (action) {
        switch (action.action) {
          case 'asistencia':
            this.id_calendar = action.record.id
            this.modalVisible = true
            break
          case 'masterEdit':
            if (!this.$isEmpty(action.record.trainer)) {
              this.$refs.capacitador && this.$refs.capacitador.handleSearch(action.record.trainer)
            }
            if (!this.$isEmpty(action.record.id_h_trainer_type)) {
              this.$refs.tipo_capacitador && this.$refs.tipo_capacitador.handleChange(action.record.id_h_trainer_type)
            }
            break
        }
      },
      updateNotification (notification, id, resolve, reject) {
        this.loading = true
        this.httpClient.getInstance().put(this.master.endpoint + '/' + id, {
          notification: notification
        })
          .then(() => {
            this.$refs.master.$refs.datatable.loadData()
            resolve()
          })
          .catch((error) => {
            Mensajes.error('Error', 'No fue posible activar o desactivar las notificaciones')
            reject(error)
            this.loading = false
          }).then(() => {
            this.loading = false
          })
      },
      handleCancel (e) {
        this.modalVisible = false
      },
      columnaCambiada (topic) {
        this.loadingBtn[topic.id] = true
        this.$forceUpdate()
        this.httpClient.getInstance().post('trn_qualifications', {
          qualification: topic.qualification,
          id_competitor: topic.id_competitor,
          evaluator: true,
          id_calendar: topic.id_calendar,
          isassistance: false
        }).then(() => {
          this.$refs.master && this.$refs.master.$refs.datatable.loadData()
        }).catch((error) => {
          Mensajes.error(this.$getErrorMessage(error, 'No fue posible guardar la calificación.'))
        }).then(() => {
        })
        this.loadingBtn[topic.id] = false
        this.$forceUpdate()
      },
      loadingIn (record) {
        if (this.loadingBtn.hasOwnProperty(record.id)) {
          return this.loadingBtn[record.id]
        } else {
          return false
        }
      },
      yearsSelect () {
        for (let i = this.yearToday; i <= (this.yearToday + 4); i++) {
          this.years.push(i)
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_training: this.id_training
        }
      },
      modalParenData () {
        return {id_calendar: this.id_calendar}
      },
      isInternal () {
        let result = false
        if (this.capacitorType.hasOwnProperty('text')) {
          result = this.capacitorType['text'] === 'INTERNO'
        }
        if (!result) {
          this.$refs.master && this.$refs.master.modal.form.setFieldsValue({
            trainer: null
          })
        } else {
          this.$refs.master && this.$refs.master.modal.form.setFieldsValue({
            externa_trainer_id_person: null,
            external_trainer_name: null,
            external_trainer_email: null
          })
        }
        return result
      },
      rowSelected () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Capacitaciones/Calendar.vue